import { render, staticRenderFns } from "./serviceForm.vue?vue&type=template&id=e201e8f6&scoped=true"
import script from "./serviceForm.vue?vue&type=script&lang=js"
export * from "./serviceForm.vue?vue&type=script&lang=js"
import style0 from "./serviceForm.vue?vue&type=style&index=0&id=e201e8f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e201e8f6",
  null
  
)

export default component.exports